import { Badge, Table } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { SubscriptionStatus } from '@/types/subscription'
import { getFormattedDate } from '@/utils/date'

type LicenseStatusProps = {
  status: SubscriptionStatus
}

const LicenseStatus = ({ status }: LicenseStatusProps) => {
  if (status === SubscriptionStatus.Active) {
    return (
      <Badge size="xs" color="green">
        <FormattedMessage id="subscriptions.status.active" />
      </Badge>
    )
  }

  return null
}

type BillingSummaryProps = {
  billingContactEmail: string
  startDate: string
  endDate: string
  status: SubscriptionStatus
}

export const BillingSummary = ({
  billingContactEmail,
  startDate,
  endDate,
  status
}: BillingSummaryProps) => {
  return (
    <Table
      variant="vertical"
      layout="fixed"
      verticalSpacing="sm"
      horizontalSpacing="md"
      withTableBorder
    >
      <Table.Tbody>
        <Table.Tr>
          <Table.Th w={240}>
            <FormattedMessage id="subscriptions.billingContact" />
          </Table.Th>

          <Table.Td>{billingContactEmail}</Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="subscriptions.startDate" />
          </Table.Th>

          <Table.Td>{getFormattedDate(startDate)}</Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="subscriptions.endDate" />
          </Table.Th>

          <Table.Td>{getFormattedDate(endDate)}</Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="subscriptions.status" />
          </Table.Th>

          <Table.Td>
            <LicenseStatus status={status} />
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  )
}
